export { default as ListView } from 'employees/components/EmployeesListView';
export { default as FormView } from 'employees/components/EmployeeFormView';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/components/index.js